export const SETUP_STEPS_COPY = {
  buildingMessage:
    "We're building your agent. This can take up to 10 minutes. Grab a coffee, you'll be able to talk to it shortly",
  completeMessage:
    'Everything is set! Click "Continue" on the right to talk to your agent',
} as const;
